var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCreated)?_c('li',{staticClass:"l-side-rooms__item"},[_c('router-link',{staticClass:"l-side-rooms__link",attrs:{"to":{
      name: 'room',
      query: {
        partner: _vm.partner.id,
        project: _vm.project.id,
        r: _vm.role.query,
        proxyUserId: _vm.$route.query.proxyUserId
      }
    },"exact":""}},[(_vm.isCompany)?_c('div',{staticClass:"l-side-rooms__avatar"},[_c('Avatar',{attrs:{"src":_vm.partner.avatar}})],1):_vm._e(),_c('div',{staticClass:"l-side-rooms__name"},[_vm._v("\n      "+_vm._s(_vm.roomName)+"\n    ")]),_c('transition',{attrs:{"name":"v-fade--delay"}},[(!_vm.isCurrent && _vm.roomCountUnread)?_c('Badge',{attrs:{"variant":"count"}},[_vm._v("\n        "+_vm._s(_vm._f("roundNumberText")(_vm.roomCountUnread,100))+"\n      ")]):_vm._e()],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }